import React from "react";

/*
  PatCausalScopePanel.jsx
  --------------------------------
  Explicit user selection of a single
  causal question when multiple are detected.
*/

export default function PatCausalScopePanel({ scope, onSelect }) {
  if (
    !scope ||
    !Array.isArray(scope.candidates) ||
    scope.candidates.length === 0
  ) {
    return null;
  }

  return (
    <div className="rounded-lg border border-amber-600/60 bg-slate-900/70 p-4 space-y-4">
      <h3 className="text-sm font-semibold text-amber-300">
        Multiple causal pathways detected
      </h3>

      <p className="text-xs text-slate-400">
        This input contains more than one plausible causal question or decision
        pathway. Pearlian causal analysis requires a single, clearly scoped
        causal claim. Please select the question you want to analyse.
      </p>

      <div className="space-y-2">
        {scope.candidates.map((c) => (
          <button
            key={c.id}
            onClick={() => onSelect(c)}
            className="w-full text-left px-3 py-2 rounded border border-slate-700
                       bg-slate-800/60 hover:bg-slate-700/60
                       text-sm text-slate-200 transition"
          >
            {c.summary}
          </button>
        ))}
      </div>

      <p className="text-[0.7rem] text-slate-500">
        Selecting a pathway does not assert truth. It simply defines the scope
        for causal modelling.
      </p>
    </div>
  );
}
